import { useEffect } from "react";

import { AppPricingData } from "src/contentful";

import { PricingContentContextProvider } from "@/components/wpl/pricing/src/pricing-content-context";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";
import { PricingContent } from "@/utils/pricing-queries/get-pricing-content";
import { UserLocale } from "@/utils/useGeoCurrency";

import { SoftwareGuardPricingPageTemplate } from "../../../../templates/software/guard/pricing/software-guard-pricing-page/src";

// If your page doesn't have props, then obviously don't include this
export type SoftwareGuardPricingPageProps = {
    pricing?: AppPricingData;
    countryCode?: UserLocale;
    pricingContent?: PricingContent;
};
export const SoftwareGuardPricingPage = ({
    pricing,
    countryCode,
    pricingContent
}: SoftwareGuardPricingPageProps) => {
    useEffect(() => {
        checkFeatureFlagGate(featureFlags.cpapiwdPricingAll);
    }, []);

    return (
        <PricingContentContextProvider
            productId="atlassian-access"
            pricingContent={pricingContent}
        >
            <div data-testid="guard-pricing-page">
                <SoftwareGuardPricingPageTemplate
                    pricing={pricing}
                    countryCode={countryCode}
                />
            </div>
        </PricingContentContextProvider>
    );
};
